module.exports = __webpack_public_path__ + "img/ug551.8f1eeaac.png";